// Versão é alterada depois do npm run build
const VERSION = '__BUSER_RELEASE_VERSION__'
export default VERSION
